module.exports = "<ng-container *ngIf=\"(item|meta); let meta\">\n    <h2>{{meta.title}}</h2>\n    <small class=\"item-sub-title\">{{meta.counts_text | uppercase}}</small>\n    <br><br>\n    <p [innerHtml]=\"meta.description\"></p>    \n    <div class=\"tags-container\">\n        <tags [items]=\"meta.tag_endpoints \" class=\"higlight-tags \"></tags>\n    </div>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/series/detail-view/detail-view.template.html
// module id = 811
// module chunks = 2